// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"eb553546","495":"eb553546"}[chunkId] + ".chunk.css";
};